import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Button, Input, Form, Select, Spin, message } from 'antd';
import debounce from 'lodash/debounce';
import useAxios from './../../../CustomHooks/useAxios';

const { Option } = Select;

function DebounceSelect({ fetchOptions, debounceTimeout = 350, ...props }) {
    const [fetching, setFetching] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const fetchRef = React.useRef(0);

    const debounceFetcher = React.useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions([]);
            setFetching(true);
            fetchOptions(value).then((newOptions) => {
                if (fetchId !== fetchRef.current) {
                    return;
                }
                setOptions(newOptions);
                setFetching(false);
            });
        };
        return debounce(loadOptions, debounceTimeout);
    }, [fetchOptions, debounceTimeout]);

    return (
        <Select
            allowClear
            labelInValue
            filterOption={false}
            onSearch={debounceFetcher}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            {...props}
            options={options}
        />
    );
}

export default function AddAgency({ setVisibleAdd, setRefreshSearch }) {
    const { axiosi } = useAxios();
    const [companyid, setCompanyid] = React.useState(null);
    const user = useSelector((state) => state.loginReducer.user);
    const [hideItem, setHideItem] = useState('');

    useEffect(() => {
        if (user?.agents) {
            if (user?.agents[0].company_id !== 1) {
                setHideItem('hideItem');
            } else {
                setHideItem('col');
            }
        }
    }, [user?.agents]);

    async function fetchUserList(company_name) {
        console.log('fetching user', company_name);
        const body = await axiosi.get('companies', { params: { company_name, pageSize: 100 } });
        if (body?.data?.rows) {
            return body?.data?.rows.map((user) => ({
                label: user.company_name,
                value: user.id,
            }));
        } else {
            return [];
        }
    }

    const onFinishAdd = async (values) => {
        console.log("[onFinishAdd]:values=", values);
        try {
            const dataToSubmit = {
                ...values,
                company_id: companyid ? companyid.value : undefined
            };
            const kq = await axiosi.post("agencies", dataToSubmit);
            console.log("[onFinishAdd]:kq=", kq);
            setVisibleAdd(false);
            setRefreshSearch(pre => !pre);
        } catch (error) {
            if (error.response) {
                console.log(error.response.data);
                message.error(`Error: ${error.response.data.message || error.response.data.code}`);
            } else {
                console.log('Error', error.message);
                message.error(`Error: ${error.message}`);
            }
        }
    };

    const onFinishFailedAdd = (error) => {
        console.log("[onFinishFailedAdd]:error=", error);
    };

    return (
        <Form
            name="basic"
            labelCol={{ span: 9 }}
            wrapperCol={{ span: 15 }}
            initialValues={{ activestatus: 1 }}
            onFinish={onFinishAdd}
            onFinishFailed={onFinishFailedAdd}
            autoComplete="off"
        >
            <Form.Item className={hideItem}
                label="Company"
                rules={[{ required: (hideItem !== "hideItem"), message: 'Please select a company!' }]}
            >
                <DebounceSelect
                    showSearch={true}
                    value={companyid}
                    placeholder="Select company"
                    fetchOptions={fetchUserList}
                    onChange={(newValue) => {
                        setCompanyid(newValue);
                    }}
                    style={{
                        width: '100%',
                    }}
                />
            </Form.Item>

            <Form.Item
                label="Agency Name"
                name="name"
                rules={[{ required: true, message: 'Please input agency name!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Note"
                name="note"
            >
                <Input.TextArea />
            </Form.Item>

            <Form.Item
                label="Status"
                name="activestatus"
                rules={[{ required: true, message: 'Please select status!' }]}
            >
                <Select>
                    <Option value={1}>Active</Option>
                    <Option value={0}>Deactivate</Option>
                </Select>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit">
                    Save
                </Button>
            </Form.Item>
        </Form>
    );
}
